module.exports = __webpack_public_path__ + "static/media/wheel-green.7cfa6c3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/wheel-green.png
// module id = 743
// module chunks = 0